import React from 'react';
import { a as _taggedTemplateLiteral } from './_rollupPluginBabelHelpers-53ddb3bb.js';
import styled, { css } from 'styled-components';

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n      grid-column: auto;\n    "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n        grid-column: auto / span ", ";\n      "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n        grid-column: auto / ", ";\n      "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n        grid-column: ", " / auto;\n      "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n        grid-column: span ", " / ", ";\n      "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n        grid-column: ", " / span ", ";\n      "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n        grid-column: ", " / ", ";\n      "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  place-self: stretch;\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Item = styled.div(_templateObject(), function (_ref) {
  var start = _ref.start,
      end = _ref.end,
      span = _ref.span;

  if (start && end) {
    return css(_templateObject2(), start, end);
  }

  if (start && span) {
    return css(_templateObject3(), start, span);
  }

  if (end && span) {
    return css(_templateObject4(), span, end);
  }

  if (start && !end && !span) {
    return css(_templateObject5(), start);
  }

  if (!start && end && !span) {
    return css(_templateObject6(), end);
  }

  if (!start && !end && span) {
    return css(_templateObject7(), span);
  }

  return css(_templateObject8());
});

var GridItem = function GridItem(_ref) {
  var span = _ref.span,
      start = _ref.start,
      end = _ref.end,
      children = _ref.children,
      className = _ref.className;
  return React.createElement(Item, {
    span: span,
    start: start,
    end: end,
    className: className
  }, children);
};

GridItem.defaultProps = {
  className: null,
  end: null,
  span: null,
  start: null
};
GridItem.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "GridItem",
  "props": {
    "className": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "A custom className you would like to pass to the Component"
    },
    "end": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "union",
        "value": [{
          "name": "number"
        }, {
          "name": "string"
        }]
      },
      "required": false,
      "description": "The grid line the item will end on"
    },
    "span": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "union",
        "value": [{
          "name": "number"
        }, {
          "name": "string"
        }]
      },
      "required": false,
      "description": "How many grid tracks the item will span"
    },
    "start": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "union",
        "value": [{
          "name": "number"
        }, {
          "name": "string"
        }]
      },
      "required": false,
      "description": "The grid line the item will start on"
    },
    "children": {
      "type": {
        "name": "union",
        "value": [{
          "name": "node"
        }, {
          "name": "arrayOf",
          "value": {
            "name": "node"
          }
        }]
      },
      "required": true,
      "description": "The children of the Grid"
    }
  }
};
export default GridItem;
export { GridItem };